import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import M from "materialize-css";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";

function NewInviteCode(props) {
const [code, setCode] = useState('');const [emailUsedInSignup, setEmailUsedInSignup] = useState('');

  const [inviteCodeCreated, setInviteCodeCreated] = useState(false);
  const [showError, setShowError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const { firestore } = props;

  useEffect(() => {
    M.AutoInit();
    M.updateTextFields();
  }, []);

  const validateInviteCode = () => {
    //TODO: needs to be validated
    return true;
  };

  const createInviteCode = () => {
    const newInviteCode = {
      code: code,
    };

    if (emailUsedInSignup) {
      newInviteCode.emailUsedInSignup = emailUsedInSignup;
    }

    if (!validateInviteCode(newInviteCode)) {
      setMessageError("InviteCode is no valid");
      setShowError(true);
      return;
    }

    firestore
      .collection("inviteCodes")
      .doc()
      .set(newInviteCode)
      .then(() => {
        console.log("InviteCode created");
        setInviteCodeCreated(true);
      })
      .catch((e) => console.error(e));
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (inviteCodeCreated) return <Redirect to="/codes" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <div className="col s12">
                <h4>New InviteCode</h4>
              </div>
            </div>
<div className="row"><div className="input-field col s12"><input id="code" type="text" className="validate" name="code" value={code} onChange={(e) => setCode(e.target.value)} /><label htmlFor="code">Code</label></div></div><div className="row"><div className="input-field col s12"><input id="emailUsedInSignup" type="text" className="validate" name="emailUsedInSignup" value={emailUsedInSignup} onChange={(e) => setEmailUsedInSignup(e.target.value)} /><label htmlFor="emailUsedInSignup">Email</label></div></div>
          </div>
          {showError && (
            <div className="card-action">
              <h6 className="red-text">{messageError}</h6>
            </div>
          )}
          <div className="card-action">
            <a
              href="#create"
              className="waves-effect waves-light btn btn-large"
              onClick={createInviteCode}
            >
              Create
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    inviteCodes:
      state.firestore.ordered.inviteCodes,
    auth: state.firebase.auth,
  };
};

export default compose(
  firestoreConnect([
    { collection: "inviteCodes", orderBy: ["code", "asc"] },
  ]),
  connect(mapStateToProps)
)(NewInviteCode);
